import { LoadingOverlay } from '@mantine/core';
import { createFileRoute, useRouter, useSearch } from '@tanstack/react-router';
import { useEffect } from 'react';

export const Route = createFileRoute('/_app/enter-code')({
	component: RouteComponent,
});

function RouteComponent() {
	const params: { code: string } = useSearch({ from: '/_app/enter-code' });
	const router = useRouter();
	useEffect(() => {
		if (params?.code) {
			router.navigate({ to: '/scan', search: { code: params.code } });
		}
	}, [params?.code, router]);
	return <LoadingOverlay />;
}
